export const truncate = (str: string, max: number, lead?: string) => {
  return str.length >= max ? str + lead : str;
}